export const LABELS = {
  'DYNAMIC_DESCRIPTION': "Updates over time adding new contacts that match your criteria and removing contacts that no longer meet that criteria.",
  'STATIC_DESCRIPTION': "Static Segments are like snapshots. If you want to update a static segment in the future, you can do it manually.",
}